module.exports = __webpack_public_path__ + "img/warning-round-icon.295c067c.svg";